module.exports = __webpack_public_path__ + "static/media/responsibility-equity.dbaa72cc.jpg";